import log from "loglevel";
export const ENV = {
    DEV: "dev",
    LOCAL: "local",
    STAGING: "staging",
    PRODUCTION: "production",
};
const commonVar = {
    version: "0.0.1",
    REFRESH_TOKEN_BEFORE_SEC: 120,
    REFRESH_TOKEN_RETRY: 3,
    REFRESH_TOKEN_RETRY_INTERVAL_ML: 2000,
    MAX_CHARACTERS_SEARCH_INPUT: 2,
    TOOLTIP_DEBOUNCE_TIME: 600,
    API_IMPORT_DEBOUNCE: 60 * 5000,
    HOUR_TO_NOTIFY_UNREPORTED_AD: 17,
    MIN_TO_NOTIFY_UNREPORTED_AD: 0,
    MIN_TO_DOBLE_NOTIFY_UNREPORTED_AD: 30,
    PERIOD_CHECK_UNREPORTED_IN_DAYS: 4,
    SEARCH_INPUT_DEBOUNCE_TIME: 300,
    FR_UNREPORTED_COUNT_MS: 60*1000
};
const local = {
    env: ENV.LOCAL,
    isLocal: true,
    api: "http://localhost:8090",

    bccEmail: "mpaa@gmail.com",
    ssoUrl: "/saml2/authenticate/mpa",
    debug: true,
};
const prod = {
    env: ENV.PRODUCTION,
    isProduction: true,
    testEmail: null,
    bccEmail: "advert@motionpictures.org;",
    api: "https://ats-cloud.motionpictures.org/api",
    ssoUrl: "/saml2/authenticate/mpa",
    debug: false,
};
const staging = {
    env: ENV.STAGING,
    isProduction: true,
    testEmail: null,
    bccEmail: "stacy_pearlman@motionpictures.org;",
    api: "https://atsstg-cloud.motionpictures.org/api",
    ssoUrl: "/saml2/authenticate/mpa",
    debug: false,
};
const dev = {
    env: ENV.DEV,
    isDev: true,
    bccEmail: "mpaa@gmail.com",
    api: "https://ats-server-dev.media-qurator.com",
    ssoUrl: "/saml2/authenticate/mpa",
    debug: true,
};
function _loadEnv() {
    const env = process.env.CONF_ENV;
    log.debug("ENV loaded: ", env);
    if (env === ENV.LOCAL) {
        return local;
    }
    if (env === ENV.DEV) {
        return dev;
    }
    if (env === ENV.STAGING) {
        return staging;
    }
    if (env === ENV.PRODUCTION || env == "prod") {
        return prod;
    }
    return null;
}
const currentEnv = {
    ...commonVar,
    ..._loadEnv(),
};
export default Object.freeze(currentEnv);
